"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const BoldArrow_1 = __importDefault(require("./BoldArrow"));
const MiniMap_1 = require("./MiniMap");
const react_ui_1 = require("@pasport/react-ui");
function PanoramaMiniMarker({ initYaw, onClick }) {
    const [yaw, setYaw] = react_1.default.useState(initYaw);
    (0, react_1.useEffect)(() => {
        const handler = (e) => {
            const yaw = e.detail;
            setYaw(yaw);
        };
        window.addEventListener(MiniMap_1.miniMapYawEventString, handler);
        return () => {
            window.removeEventListener(MiniMap_1.miniMapYawEventString, handler);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            transform: `rotate(90deg) rotate(10deg) rotate(${yaw}rad)`
        }, onClick: onClick, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    transform: `translate(-50%, -50%) translate(-20px, 0)`,
                    position: "absolute",
                    top: 0,
                    left: 0
                }, children: (0, jsx_runtime_1.jsx)(BoldArrow_1.default, { color: "light", size: 20, bold: 2 }) }), (0, jsx_runtime_1.jsx)("div", { style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    display: "flex",
                    transform: "translate(-50%, -50%)"
                }, children: (0, jsx_runtime_1.jsx)(react_ui_1.Circle, { size: 20, color: "light" }) }), (0, jsx_runtime_1.jsx)("div", { style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    display: "flex",
                    transform: "translate(-50%, -50%)"
                }, children: (0, jsx_runtime_1.jsx)(react_ui_1.Circle, { size: 14, color: "primary" }) })] }));
}
exports.default = PanoramaMiniMarker;
